// src/utils/formUtils.js

/**
 * Ensures a value is a plain object (for person_data / form data).
 * Forms from anywhere should save object data only — never stringify when persisting.
 */
export const ensurePlainObject = (value) => {
  if (value == null) return {};
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return typeof parsed === "object" && parsed !== null && !Array.isArray(parsed) ? parsed : {};
    } catch {
      return {};
    }
  }
  if (typeof value === "object" && !Array.isArray(value)) return value;
  return {};
};

/**
 * Flatten Form.io phone container / string to display string.
 * Handles { phoneNumber1, fullPhoneNumber, country? } from guest meta.
 */
export const formatPhoneDisplay = (value) => {
  if (value == null || value === "") return "";
  if (typeof value === "string" || typeof value === "number") {
    return String(value).trim();
  }
  if (typeof value !== "object" || Array.isArray(value)) return "";

  if (value.fullPhoneNumber) return String(value.fullPhoneNumber).trim();

  const digits = value.phoneNumber1 || value.phoneNumber || value.phoneNumberDigits || "";
  const dial =
    value.country && typeof value.country === "object" && value.country.dial_code
      ? String(value.country.dial_code).trim()
      : value.countryCode
        ? String(value.countryCode).trim()
        : "";
  return `${dial}${digits}`.trim();
};

// Save a form schema to local storage
export const saveFormToLocal = (formSchema) => {
    let forms = JSON.parse(localStorage.getItem('forms')) || [];
    forms.push(formSchema);
    localStorage.setItem('forms', JSON.stringify(forms));
  };
  
  // Get all forms from local storage
  export const getFormsFromLocal = () => {
    return JSON.parse(localStorage.getItem('forms')) || [];
  };

  // Update a specific form in local storage
export const updateFormInLocal = (index, updatedFormSchema) => {
    let forms = JSON.parse(localStorage.getItem('forms')) || [];
    forms[index] = updatedFormSchema;
    localStorage.setItem('forms', JSON.stringify(forms));
  };

  // Save a form submission to local storage
export const saveFormSubmissionToLocal = (formIndex, submission) => {
    let submissions = JSON.parse(localStorage.getItem('submissions')) || {};
    if (!submissions[formIndex]) {
      submissions[formIndex] = [];
    }
    submissions[formIndex].push(submission);
    localStorage.setItem('submissions', JSON.stringify(submissions));
  };
  
  // Get form submissions from local storage
  export const getFormSubmissionsFromLocal = (formIndex) => {
    let submissions = JSON.parse(localStorage.getItem('submissions')) || {};
    return submissions[formIndex] || [];
  };

  export const deleteFormFromLocal = (formIndex) => {
    let forms = JSON.parse(localStorage.getItem('forms')) || [];
    forms.splice(formIndex, 1); // Remove the form from the array
    localStorage.setItem('forms', JSON.stringify(forms));
  
    // Optionally delete the associated submissions as well
    let submissions = JSON.parse(localStorage.getItem('submissions')) || {};
    delete submissions[formIndex]; // Remove submissions related to the deleted form
    localStorage.setItem('submissions', JSON.stringify(submissions));
  };